import { useCallback, useMemo, useState } from "react";

import { IAdjustCoverageInput } from "gql/queries/estimate";
import { CoverageType } from "router/CoverageEditorRoute/CoverageEditorRoute";
import { useAppDispatch } from "store";
import { adjustEstimate } from "store/actions/estimate";
import { adjustProductOffering } from "store/actions/product-offerings";
import { adjustQuote } from "store/actions/quote";

import { debounce } from "lodash-es";

type StatusTypes = "inactive" | "active" | "in-flight";

export const useAdjustCoverage = (type: CoverageType) => {
  const [status, setStatus] = useState<StatusTypes>("inactive");
  const dispatch = useAppDispatch();

  const adjustCoverageAmount = useCallback(
    async (payload: IAdjustCoverageInput) => {
      setStatus("in-flight");

      let adjustAction;
      switch (type) {
        case "estimate":
          adjustAction = adjustEstimate(payload);
          break;
        case "termLifeOffering":
          adjustAction = adjustProductOffering({
            ...payload,
          });
          break;
        case "adOffering":
          adjustAction = adjustProductOffering(payload);
          break;
        default:
          adjustAction = adjustQuote(payload);
          break;
      }

      const coverageQuery = await dispatch(adjustAction);

      setStatus("inactive");

      return coverageQuery;
    },
    [type, dispatch]
  );

  const debounceAdjustCoverage = useMemo(
    () => debounce(adjustCoverageAmount, 500),
    [adjustCoverageAmount]
  );

  const adjustCoverage = (payload: IAdjustCoverageInput) => {
    setStatus("active");

    return debounceAdjustCoverage(payload);
  };

  return { status, adjustCoverage };
};
